import { getProductInventory } from 'pricing-pages-lib/api/ProductInventoryApi';
import { PRODUCT_INVENTORY } from './constants/RequestedDataTypes';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchProductInventoryRequestTypes = createRequestTypes(PRODUCT_INVENTORY);
export const FetchProductInventoryActions = createRequestActions(FetchProductInventoryRequestTypes);
export const fetchProductInventoryData = () => makeFetchRequest({
  requestActions: FetchProductInventoryActions,
  fetch: getProductInventory
});